import { INotificationMessage } from "@fl/shared/src/types/messages";
import {
  CertificadoAttributes,
  CertificadosPerCondsAttributes,
} from "@fl/shared/src/types/models/suporte_fl/certificados";
import {
  IDataExcel,
  IDataPDF,
  IExcelColumn,
} from "@fl/shared/src/types/reports";
import { ITableDataColumns } from "@fl/shared/src/types/tables";
import moment from "moment";
import { TableCell } from "pdfmake/interfaces";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { BsCircleFill } from "react-icons/bs";
import { FaListAlt, FaRegListAlt } from "react-icons/fa";
import { IoMdAddCircle, IoMdAddCircleOutline } from "react-icons/io";
import ButtonGenerateReport from "../../../../components/generateReport";
import { ExportDatas } from "../../../../components/generateReport/exportData";
import CertificadoModal from "../../../../components/modals/certificados/add";
import ListCertificadoModal from "../../../../components/modals/certificados/list";
import TableData from "../../../../components/tables";
import { useNotificationContext } from "../../../../context/notifications";
import ApiCertificados from "../../../../services/suporte/auth/certificados";
import SortFunctions from "../../../../utils/sortArrays";
import { formatAddress } from "../../../../utils/stringsFormats";
import StringsFuncs from "../../../../utils/stringsFuncs";
import DefaultBasePage from "../../../default/base";

export interface ICertDataModal {
  condominio: string;
  id_condominio_cond: number;
  certificates: CertificadoAttributes[];
}

const CondominiosCertificadosPrivatePage = () => {
  const columnsTable: ITableDataColumns[] = [
    {
      columnKey: "id_condominio_cond",
      label: "#ID",
      pk: true,
      showColumn: false,
      alignText: "text-center",
    },
    { columnKey: "st_label_cond", label: "Código", alignText: "text-center" },
    {
      columnKey: "st_nome_cond",
      label: "Condomínio",
      alignText: "text-start",
    },
    {
      columnKey: "status",
      label: "Situação",
      alignText: "text-center",
      render: (item: CertificadosPerCondsAttributes) => {
        if (item.fl_ativo_cond === 1) {
          return (
            <BsCircleFill size={13} color="green" title="Condomínio Ativo" />
          );
        } else {
          return (
            <BsCircleFill size={13} color="red" title="Condomínio Inativo" />
          );
        }
      },
      //disableSort: true,
      sortValue: (item: CertificadosPerCondsAttributes) => item.fl_ativo_cond,
    },
    {
      columnKey: "Endereco",
      label: "Endereço",
      alignText: "text-justify",
      render: (item: CertificadosPerCondsAttributes) => {
        return formatAddress(
          item.st_endereco_cond,
          item.st_numeroendereco_cond,
          item.st_complemento_cond,
          item.st_cep_cond,
          item.st_bairro_cond,
          item.st_cidade_cond
        );
      },
      sortValue: (item: CertificadosPerCondsAttributes) => {
        return item.st_endereco_cond?.toLowerCase() || "";
      },
    },
    {
      columnKey: "Certificado", // chave que referencia o array
      label: "Certificado",
      alignText: "text-center",
      render: (item: CertificadosPerCondsAttributes) => {
        const certificados = item.Certificados || [];
        const cert = certificados
          .sort((a, b) =>
            new SortFunctions(a.createdAt, b.createdAt).sortDateDesc()
          )
          .find((item) => moment(item.data_expiracao));

        const dias = cert
          ? moment(cert.data_expiracao).diff(moment(), "day")
          : 0;

        return cert ? (
          <div key={cert.id_certificado}>
            <div>{cert.arquivo}</div>
            <div>Emissão: {moment(cert.data_emissao).format("DD/MM/YYYY")}</div>
            <div>
              Expiração: {moment(cert.data_expiracao).format("DD/MM/YYYY")}
            </div>
            <div
              style={
                dias > 60
                  ? {
                      backgroundColor: "MediumSpringGreen",
                      borderRadius: "10px",
                      padding: "0px 3px",
                    }
                  : dias > 30
                    ? {
                        backgroundColor: "Gold",
                        borderRadius: "10px",
                        padding: "0px 3px",
                      }
                    : dias >= 0
                      ? {
                          backgroundColor: "LightCoral",
                          borderRadius: "10px",
                          padding: "0px 3px",
                        }
                      : {
                          backgroundColor: "red",
                          borderRadius: "10px",
                          padding: "0px 3px",
                          color: "yellow",
                          // backgroundImage:
                          //   "linear-gradient(0deg, rgba(255,0,0,1) 0%, rgba(241,255,50,0.98) 50%, rgba(255,0,0,1) 100%)",
                          // borderRadius: "10px",
                          // padding: "0px 3px",
                          // color: "black", // Para contraste
                          // textAlign: "center", // Centralizar o texto
                        }
              }
            >
              {dias <= 0
                ? `Vencido há ${Math.abs(dias)} dia(s)`
                : `Vence em: ${dias} dia(s)`}
            </div>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: "Plum",
              borderRadius: "10px",
              padding: "0px 3px",
            }}
          >
            Nenhum certificado válido
          </div>
        );
      },
      sortValue: (item: CertificadosPerCondsAttributes) => {
        const certificados = item.Certificados || [];
        const cert = certificados.find((item) => moment(item.data_expiracao));

        const dias = cert
          ? moment(cert.data_expiracao).diff(moment(), "day")
          : -9999999999;
        return dias;
      },
    },
    {
      columnKey: "{actions}",
      label: "Ação",
      action: true,
      actionColumnIcons: true,
      alignText: "text-center",
      actionButtons: (item: CertificadosPerCondsAttributes) => {
        var buttons = [
          {
            label: `Criar Certificado (${new StringsFuncs(item.st_nome_cond).cammelCase()})`,
            icon: <IoMdAddCircleOutline size={20} />,
            iconHover: <IoMdAddCircle size={20} />,
            hover: false,
            action: (i: CertificadosPerCondsAttributes) => {
              setSelectedCertificado({
                condominio: i.st_nome_cond!.toString(),
                id_condominio_cond: i.id_condominio_cond,
                certificates: [],
              });
              setShowModalAddCert(true);
            },
          },
        ];

        if (item.Certificados.length > 0) {
          buttons.push({
            label: "Listar Certificados",
            icon: <FaRegListAlt size={19} />,
            iconHover: <FaListAlt size={19} />,
            hover: false,
            action: (i: CertificadosPerCondsAttributes) => {
              const certs = certificados.find(
                (item) => item.id_condominio_cond === i.id_condominio_cond
              );
              setSelectedCertificado({
                condominio: i.st_nome_cond!.toString(),
                id_condominio_cond: i.id_condominio_cond,
                certificates: !certs
                  ? []
                  : certs.Certificados.sort((a, b) =>
                      new SortFunctions(
                        a.data_expiracao,
                        b.data_expiracao
                      ).sortDateDesc()
                    ),
              });
              setShowModalListCerts(true);
            },
          });
        }

        return [...buttons];
      },
    },
  ];

  const { addNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<INotificationMessage[]>([]);
  const [showModalAddCert, setShowModalAddCert] = useState(false);
  const [showModalListCerts, setShowModalListCerts] = useState(false);
  const [certificados, setCertificados] = useState<
    CertificadosPerCondsAttributes[]
  >([]);
  const [certificadosFiltered, setCertificadosFiltered] = useState<
    CertificadosPerCondsAttributes[]
  >([]);
  const [selectedCertificado, setSelectedCertificado] =
    useState<ICertDataModal | null>(null);
  useState<{ cond: ICertDataModal; certs: CertificadoAttributes[] } | null>(
    null
  );

  const [listActivesOnly, setListActivesOnly] = useState(true);

  useEffect(() => {
    const loadConds = async () => {
      const result = await new ApiCertificados().listPerConds(
        `?inativos=${listActivesOnly ? "0" : "1"}`
      );

      if (result.success) {
        const certs: CertificadosPerCondsAttributes[] = result.data;
        setCertificados(
          certs.sort((a, b) =>
            new SortFunctions(
              parseFloat(a.st_label_cond || "0"),
              parseFloat(b.st_label_cond || "0")
            ).sortNumberAsc()
          )
        );
      } else {
        if (result.message) setMessages(result.message);
      }
    };

    loadConds();
  }, [listActivesOnly]);

  useEffect(() => {
    setCertificadosFiltered(certificados);
  }, [certificados]);

  const onResultCertificado = async (data: ICertDataModal | null) => {
    try {
      setLoading(true);
      if (data) {
        const result = await new ApiCertificados({ ...data }).create();
        if (result.success) {
          setCertificados((prevCertificados) => {
            return prevCertificados.map((item) => {
              if (item.id_condominio_cond === data.id_condominio_cond) {
                return {
                  ...item,
                  Certificados: [...item.Certificados, { ...result.data }],
                };
              }
              return item;
            });
          });
        }

        if (result.message) addNotification(result.message[0]);
      }
    } finally {
      setLoading(false);
      setShowModalAddCert(false);
    }
  };

  const getExportDataExcel = (): IDataExcel => {
    const columns: IExcelColumn[] = [
      ExportDatas.col("#", 10, "center"),
      ExportDatas.col("ID Condomínio", 15, "center"),
      ExportDatas.col("Label", 10, "center"),
      ExportDatas.col("Condomínio", 70, "left"),
      ExportDatas.col("Situação (Condomínio)", 15, "center"),
      ExportDatas.col("Endereço", 70, "left"),
      ExportDatas.col("Emissão", 20, "center", "DD/MM/YYYY"),
      ExportDatas.col("Vencimento", 20, "center", "DD/MM/YYYY"),
      ExportDatas.col("Situação (Certificado)", 15, "center"),
      ExportDatas.col("Prazo Restante (dias)", 12, "center"),
      ExportDatas.col("Total de Certificados", 12, "center"),
    ];

    const rows: any[][] = certificados.map((cert, index) => {
      const address = formatAddress(
        cert.st_endereco_cond,
        cert.st_numeroendereco_cond,
        cert.st_complemento_cond,
        cert.st_cep_cond,
        cert.st_bairro_cond,
        cert.st_cidade_cond
      );

      const certs = cert.Certificados.sort((a, b) =>
        new SortFunctions(a.data_expiracao, b.data_expiracao).sortDateDesc()
      );

      const topCert = certs[0];

      const dias = topCert?.data_expiracao
        ? moment(topCert.data_expiracao).diff(moment(), "days")
        : "";

      const emissao = topCert?.data_emissao
        ? moment(topCert.data_emissao).format("DD/MM/YYYY HH:mm:ss")
        : "";

      const expiracao = topCert?.data_expiracao
        ? moment(topCert.data_expiracao).format("DD/MM/YYYY HH:mm:ss")
        : "";

      const status =
        dias === ""
          ? ""
          : parseInt(dias.toString()) > 0
            ? "Válido"
            : "Expirado";

      return [
        index + 1,
        cert.id_condominio_cond,
        cert.st_label_cond,
        cert.st_nome_cond,
        cert.fl_ativo_cond === 1 ? "Ativo" : "Inativo",
        address,
        emissao,
        expiracao,
        status,
        dias,
        cert.Certificados.length,
      ];
    });

    return ExportDatas.generateExcel({
      title: "Relatório de Certificados A1",
      sheetName: "Certificados",
      columns,
      rows,
      orientation: "landscape",
      margins: {
        left: 0.7,
        right: 0.7,
        top: 0.75,
        bottom: 0.75,
        header: 0.3,
        footer: 0.3,
      },
    });
  };

  const buildExportDataPDF = (): IDataPDF => {
    const columns: TableCell[] = [
      { text: "#", alignment: "center", bold: true },
      { text: "ID Condomínio", alignment: "center", bold: true },
      { text: "Label", alignment: "center", bold: true },
      { text: "Condomínio", alignment: "center", bold: true },
      { text: "Situação (Cond.)", alignment: "center", bold: true },
      { text: "Endereço", alignment: "center", bold: true },
      { text: "Emissão", alignment: "center", bold: true },
      { text: "Vencimento", alignment: "center", bold: true },
      { text: "Situação (Cert.)", alignment: "center", bold: true },
      { text: "Prazo (dias)", alignment: "center", bold: true },
      { text: "Total de Certificados", alignment: "center", bold: true },
    ];

    const rows: TableCell[][] = certificados.map((cert, index) => {
      const address = formatAddress(
        cert.st_endereco_cond,
        cert.st_numeroendereco_cond,
        cert.st_complemento_cond,
        cert.st_cep_cond,
        cert.st_bairro_cond,
        cert.st_cidade_cond
      );

      const certs = cert.Certificados.sort((a, b) =>
        new SortFunctions(a.data_expiracao, b.data_expiracao).sortDateDesc()
      );

      const topCert = certs[0];
      const dias = topCert?.data_expiracao
        ? moment(topCert.data_expiracao).diff(moment(), "days")
        : "";
      const emissao = topCert?.data_emissao
        ? moment(topCert.data_emissao).format("DD/MM/YYYY HH:mm:ss")
        : "";
      const expiracao = topCert?.data_expiracao
        ? moment(topCert.data_expiracao).format("DD/MM/YYYY HH:mm:ss")
        : "";

      const status =
        dias === ""
          ? ""
          : parseInt(dias.toString()) > 0
            ? "Válido"
            : "Expirado";

      return [
        { text: index + 1, alignment: "center" },
        { text: cert.id_condominio_cond, alignment: "center" },
        { text: cert.st_label_cond, alignment: "center" },
        cert.st_nome_cond || "",
        {
          text: cert.fl_ativo_cond === 1 ? "Ativo" : "Inativo",
          alignment: "center",
        },
        address,
        { text: emissao, alignment: "center" },
        { text: expiracao, alignment: "center" },
        { text: status, alignment: "center" },
        { text: dias, alignment: "center" },
        { text: cert.Certificados.length, alignment: "center" },
      ];
    });

    return ExportDatas.generatePDF({
      title: "Relatório de Certificados A1",
      columns,
      rows,
      orientation: "landscape",
      pageSize: "A4",
      margins: [40, 60, 40, 60],
      fontSize: 6,
      headerRows: 1,
      zebraStripe: true,
    });
  };

  return (
    <DefaultBasePage
      title="Listagem de Certificados (A1)"
      subtitle={`Listagem: ${certificadosFiltered.length} condomínio(s)`}
      filterComp={true}
      dataToFilter={certificados}
      setFilteredData={setCertificadosFiltered}
      loading={loading}
      message={messages}
    >
      <div className="text-justify">
        <Form.Check
          className="my-2"
          type="switch"
          checked={listActivesOnly}
          label={
            listActivesOnly
              ? "Somente condomínios ativos"
              : "Condomínios ativos e inativos"
          }
          onChange={() => setListActivesOnly(!listActivesOnly)}
        />

        <TableData
          key={JSON.stringify(certificadosFiltered)}
          columns={columnsTable}
          data={certificadosFiltered}
        />

        <CertificadoModal
          showModal={showModalAddCert}
          data={selectedCertificado}
          onResultCertificado={onResultCertificado}
        />

        <ListCertificadoModal
          showModal={showModalListCerts}
          setShowModalListCerts={setShowModalListCerts}
          data={selectedCertificado}
        />

        <ButtonGenerateReport
          reportName="Certificados A1"
          getExportDataExcel={getExportDataExcel}
          getExportDataPDF={buildExportDataPDF}
          setMessagesExport={setMessages}
          setLoading={setLoading}
        />
      </div>
    </DefaultBasePage>
  );
};

export default CondominiosCertificadosPrivatePage;
